function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "snake-plus",
  transform: "translate(0.75 0.75)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_51",
  "data-name": "Group 51",
  transform: "translate(21.721 22.702)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_15",
  "data-name": "Rectangle 15",
  width: 2.472,
  height: 19.774,
  rx: 1.236,
  transform: "translate(8.664)",
  fill: "#012c5f"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_16",
  "data-name": "Rectangle 16",
  width: 2.718,
  height: 19.57,
  rx: 1.359,
  transform: "translate(0 11.868) rotate(-90)",
  fill: "#012c5f"
})), /*#__PURE__*/React.createElement("g", {
  id: "ouroboros_1_",
  "data-name": "ouroboros (1)",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_14",
  "data-name": "Path 14",
  d: "M68.082,8.859a31.716,31.716,0,0,0-43.975,0,29.651,29.651,0,0,0-.651,42.116,31.3,31.3,0,0,0,19.533,9.36c1.229,1.975,3.619,3.921,8.266,3.921a20.943,20.943,0,0,0,9.531-2.444c3.422-1.855,5.307-4.33,5.307-6.969a5.563,5.563,0,0,0-.166-1.341A30.745,30.745,0,0,0,73.8,43.959,29.168,29.168,0,0,0,77.19,30.245,29.637,29.637,0,0,0,68.082,8.859ZM63.961,50.19a13.425,13.425,0,0,0-3.174-2.316c-.09-.049-.183-.1-.275-.143a21.714,21.714,0,0,0,4.75-5.6,20.989,20.989,0,0,0,2.9-10.628c0-11.833-9.9-21.46-22.063-21.46S24.032,19.667,24.032,31.5a21.06,21.06,0,0,0,5.822,14.518,22.243,22.243,0,0,0,14.264,6.846,1.945,1.945,0,0,0,1.931-1.09,4.323,4.323,0,0,1,3.273-2.4v1.7a1.936,1.936,0,0,0,3.871,0V49.329c4.554.61,9.032,3.2,9.032,5.514s-4.478,4.9-9.032,5.514V58.608a1.936,1.936,0,0,0-3.871,0v1.7A4.315,4.315,0,0,1,45.994,57.8a1.934,1.934,0,0,0-1.656-1.136c-14.281-.885-25.467-12.49-25.467-26.419,0-14.6,12.213-26.48,27.224-26.48s27.224,11.879,27.224,26.48A25.922,25.922,0,0,1,63.961,50.19Zm-12.705-4.76c-4.359,0-6.725,1.723-8.008,3.54A17.737,17.737,0,0,1,27.9,31.5a18.2,18.2,0,0,1,36.385,0,17.45,17.45,0,0,1-7.966,14.627A20.032,20.032,0,0,0,51.256,45.431Z",
  transform: "translate(-15 0)",
  fill: "#012c60",
  stroke: "#fff",
  strokeWidth: 1.5
})));

function SvgSnakePlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.69,
    height: 65.755,
    viewBox: "0 0 63.69 65.755",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnakePlus);
export default __webpack_public_path__ + "static/media/snake-plus.c183f55b.svg";
export { ForwardRef as ReactComponent };